/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportViewDetails {
    getFixupPrototypeFunction() { return ReportViewDetails.fixupPrototype; }

    static newInstance(model: Partial<ReportViewDetails>): ReportViewDetails {
        let obj = Object.assign(new ReportViewDetails(), model);
        ReportViewDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportViewDetails>): ReportViewDetails {
        if (!model) return null;
        return ReportViewDetails.newInstance(<ReportViewDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportViewDetails) {
        if (!obj) return;

        models.ReportViewDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportViewDetails): boolean {
        Object.setPrototypeOf(obj, ReportViewDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Name of the View
     */
    view_name: string;

    /**
     * powerBI unique state id
     */
    state_id: string;

    /**
     * Boolean to indicate default view
     */
    default_view: boolean;

    /**
     * view created datetime
     */
    created_at: Date;

    /**
     * view latest update datetime
     */
    updated_at: Date;

}
